// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nWdSG","right":"Footer_right__1xHp4","buttons":"Footer_buttons__3Dkiz"};